import React from 'react'

import { Skeleton, Typography } from '@mui/material'
import { useOutreachSeats } from 'features/customers/hooks/useOutreachSeats'

import UsageUnavailable from './UsageUnavailable'

const CustomerOutreachSeatsUsage = () => {
  const { used, total, isPending, isError } = useOutreachSeats()

  if (isPending) return <Skeleton variant="text" width={85} />
  if (!total) return null
  // Without the users we do not know the seats in use, and "0 of N" reads as a real, empty figure.
  if (isError) return <UsageUnavailable />

  return (
    <Typography color={used >= total ? 'warning.main' : 'text.secondary'} variant="caption">
      {used} of {total} assigned
    </Typography>
  )
}

export default CustomerOutreachSeatsUsage
